
var Menu = function() {
    var currentScrollTop = 0;

    $(document).ready(function() {
        var scrollBarWidth = getScrollbarWidth();

        // Collapse menu
        $('.navbar-collapse').on('show.bs.collapse', function(e) {
            // $('.navbar-search').collapse('hide');
            $('.navbar-toggle').addClass('active');
            $('body').addClass('scroll-disabled');

            // Het menu kan hoger zijn dan het scherm. In dat geval de huidige
            // scrolltop opslaan en de body overflow hidden geven.
            // setScrollTop();
            // setTimeout(function() {
            //     $('body').addClass('scroll-disabled');
            //     $('.navbar-fixed-top').css('margin-right', scrollBarWidth);
            // }, 300);
        });
        $('.navbar-collapse').on('hide.bs.collapse', function(e) {
            $('.navbar-toggle').removeClass('active');

            // Bij het sluiten van het menu de body weer overflow scroll geven
            // en de opgeslagen scrolltop laden.
            $('body').removeClass('scroll-disabled');
            // $('.navbar-fixed-top').css('margin-right', 0);
            // window.scrollTop = currentScrollTop;
        });

        // If a main menu link was clicked and the available submenu is not visible, show the submenu and stop navigation.
		$('.navbar-main .has-submenu > a').on('click', function(e) {
			var $submenu = $(this).parent().find('.navbar-subnav');

			if (!$submenu.is(':visible') || $submenu.height() == 0) {
				e.preventDefault();
				$submenu.slideDown('fast');
			}
		});

		// Navbar search
		$('.open-navbar-search').on('click', function(e) {
			e.preventDefault();
			$(this).closest('.navbar-search').addClass('focus').find('input').focus();
		});
		$(document).on('click', function() {
			$('.navbar-search').removeClass('focus');
		});
		$('.navbar-search').on('click', function(e) {
			e.stopPropagation();
		});

        // Collapse search
        // $('.navbar-search').on('show.bs.collapse', function() {
        //     $('.navbar-custom-collapse').collapse('hide');
        //     $('.navbar-search-toggle').addClass('active');
        //
        //     setTimeout(function() {
        //         $('.navbar-search .form-control').focus();
        //     }, 500);
        // });
        // $('.navbar-search').on('hide.bs.collapse', function() {
        //     $('.navbar-search-toggle').removeClass('active');
        //     $('body').removeClass('scroll-disabled');
        //     window.scrollTop = currentScrollTop;
        // });

        // Popin dropdown menus
        $('a[data-target-popin-menu]').on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();

            if ($(this).hasClass('disabled')) {
                return;
            }

            var showContainer = $(this).data('target-popin-menu');
            $('.nav-popin-menu').not(showContainer).removeClass('active');

            if ($(showContainer).hasClass('active')) {
                $(showContainer).removeClass('active');

            } else {
                $(showContainer).addClass('active');
                $(window).trigger('resize-popin-menu');
            }
        });
        $(document).on('click', function(e) {
            $('.nav-popin-menu').removeClass('active');
        });
        $('.nav-popin-menu').on('click', function(e) {
            // e.stopPropagation();
        });
        // $(window).on('resize resize-popin-menu', function() {
        //     $('a[data-target-popin-menu]').each(function() {
        //         var $target = $($(this).data('target-popin-menu'));
		//
        //         if (!$target.hasClass('active')) {
        //             return;
        //         }
		//
        //         if ($(window).width() < 768) {
		// 			$target.css({
		// 				'right': 0,
		// 				'left': 'auto'
		// 			});
		//
        //         } else {
		// 			$target.css({
		// 				'left': 0,
		// 				'right': 'auto'
		// 			});
		// 		}
		//
        //         $target.css('top', $(this).position().top + $(this).height());
        //     });
        // });
    });

    $(document).keyup(function(e) {
        if (e.keyCode == 27) {
            $('.navbar-top .icon-button[data-toggle="collapse"].active').click();
        }
    });

    var setScrollTop = function() {
        currentScrollTop = window.scrollTop;
    };

    var getScrollbarWidth = function() {
        var $div = $('<div />').css({
            width: '100px',
            height: '100px',
            overflow: 'scroll',
            position: 'absolute',
            top: '-9999px',
        }).appendTo($('body'));

        var scrollbarWidth = $div.get(0).offsetWidth - $div.get(0).clientWidth;
        $div.remove();

        return scrollbarWidth;
    };
}();
